import _ from '@lodash';
import { Button, TableCell } from '@material-ui/core';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

function TaskManagerNavigateButton(props) {
	const { item } = props;

	const type = String((item && item.type) || '').toLowerCase();
	const prefix = type === 'calculate' ? 'TC' : type === 'optimize' ? 'TO' : 'T';

	const bgId = item && item.meta && item.meta.backgroundCalculate && item.meta.backgroundCalculate.id;

	const to = bgId ? '/what-if/edit/' + bgId + '/' + prefix + item.id : null;

	return (
		<TableCell className="w-auto" padding="none">
			{!!to && (
				<Button variant="contained" color="primary" component={Link} to={to}>
					Show&nbsp;in&nbsp;What&nbsp;If
				</Button>
			)}
		</TableCell>
	);
}

export default withRouter(TaskManagerNavigateButton);